const INCLUDED_LIST = new Intl.ListFormat("en", { type: "conjunction" });

const INCLUDED_INLINE_LIMIT = 6;

export function formatIncludedList(
    items: readonly string[] | undefined,
): string | null {
    const cleaned = (items ?? [])
        .map((item) => item.trim().replace(/\.$/, "").trim())
        .filter(Boolean);
    if (cleaned.length === 0) return null;
    if (cleaned.length <= INCLUDED_INLINE_LIMIT)
        return INCLUDED_LIST.format(cleaned);
    const shown = cleaned.slice(0, INCLUDED_INLINE_LIMIT);
    const rest = cleaned.length - shown.length;
    return `${shown.join(", ")}, +${rest} more`;
}
